export const styl = {
    scrollableTableCellStyle : {
        border: "2px solid #DFDFDF",
        borderRadius: "8px",
        height: "300px", // Set a fixed height here
        overflowY: "auto", // Enable vertical scrolling
        display: "block",
    },
}